import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../../assets/logo.png';
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "mainwidth"
};

var _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  alt: "logo",
  src: _imports_0
}, null, -1);

var _hoisted_4 = {
  class: "navlist cl canclick"
};
var _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navlist, function (item, index) {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([$data.activenav == item.path ? 'active' : '', "fl"]),
      key: index,
      onClick: function onClick($event) {
        return $options.routto(item);
      }
    }, _toDisplayString(item.name), 11, _hoisted_5);
  }), 128))])])]);
}